import { Game, eFontAsset, eAtlas_0 } from "../../Game";
import { ScaleManager } from "../../Utils/ScaleManager";
import { Gameplay } from "../Gameplay";
import * as Gamee from "../../Gamee/GameeWrapper";
import { TextureAtlasUtils } from "../../Utils/TextuAtlasUtils";



export class KeepPlaying {
    /**
     * Udalost vyvolana po dokonceni vyberu zda pokracovat nebo ne. Pokud se hrac rozhodne pokracovat, tak se udalost vyvola az po prehrani reklamy.
     * Emitter: Gameplay.events
     * Parametry:
     * res: boolean - True, pokud ma dojit k oziveni hrace
     */
    static readonly EVENT_COMPLETE = "kp:comp";

    private _screen: pc.Entity;
    private _layer: pc.Entity;
    private _overlay: pc.Entity;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(screen: pc.Entity) {
        this._screen = screen;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    show(): void {
        if (!this._layer)
            this.createLayer();

        this.updatOverlaySize();
        Game.APP.on(ScaleManager.EVENT_RESIZE, this.updatOverlaySize, this);

        this._layer.enabled = true;
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        if (this._layer && this._layer.enabled) {
            this._layer.enabled = false;
            Game.APP.off(ScaleManager.EVENT_RESIZE, this.updatOverlaySize, this);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private createLayer(): void {
        // Layer
        this._layer = new pc.Entity("keepPlaying");
        this._layer.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_GROUP,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            width: 0,
            height: 0,
        });
        this._screen.addChild(this._layer);

        // Screen Overlay
        this._overlay = new pc.Entity();
        this._overlay.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0, 0],
            color: new pc.Color(0, 0, 0),
            opacity: 0.6,
        });
        this._layer.addChild(this._overlay);

        // Okno
        let wnd = new pc.Entity();

        wnd.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_GROUP,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            width: 0,
            height: 0
        });

        this._layer.addChild(wnd);

        // Pozadi okna
        let atlas = Game.APP.assets.find(eAtlas_0.NAME, pc.eAssetType.atlas).resource as pc.TextureAtlas;

        let e = new pc.Entity();
        e.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            texture: atlas.texture,
            rect: TextureAtlasUtils.getAtlasFrameRegion(atlas, eAtlas_0.keepPlaying),
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            width: 404,
            height: 302,
        });

        wnd.addChild(e);

        // Tlacitko YES
        let sprite = new pc.Sprite(Game.APP.graphicsDevice, {
            atlas: atlas,
            frameKeys: [eAtlas_0.btnWatchAd_0, eAtlas_0.btnWatchAd_1],
            pixelsPerUnit: 1,
            renderMode: pc.SPRITE_RENDERMODE_SIMPLE
        });

        let spriteAsset = new pc.Asset("watchAdBtn", pc.eAssetType.sprite, { url: "" });
        spriteAsset.resource = sprite;
        spriteAsset.loaded = true;

        Game.APP.assets.add(spriteAsset);

        let btnYes = new pc.Entity();

        btnYes.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            width: 204,
            height: 104,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            useInput: true,
            spriteAsset: spriteAsset.id,
            spriteFrame: 0
        });

        btnYes.addComponent(pc.eCompomentType.button, {
            active: true,
            imageEntity: btnYes,
            transitionMode: pc.BUTTON_TRANSITION_MODE_SPRITE_CHANGE,
            hoverSpriteAsset: spriteAsset,
            hoverSpriteFrame: 0,
            pressedSpriteAsset: spriteAsset,
            pressedSpriteFrame: 1
        });

        btnYes.setLocalPosition(0, -20, 0);
        wnd.addChild(btnYes);

        btnYes.button.on("click", this.handleClickYesBtn, this);

        // Tlacitko NO
        sprite = new pc.Sprite(Game.APP.graphicsDevice, {
            atlas: atlas,
            frameKeys: [eAtlas_0.btnNoThanks_0, eAtlas_0.btnNoThanks_1],
            pixelsPerUnit: 1,
            renderMode: pc.SPRITE_RENDERMODE_SIMPLE
        });

        spriteAsset = new pc.Asset("NoThanksBtn", pc.eAssetType.sprite, { url: "" });
        spriteAsset.resource = sprite;
        spriteAsset.loaded = true;

        Game.APP.assets.add(spriteAsset);

        let btnNo = new pc.Entity();

        btnNo.addComponent(pc.eCompomentType.element, {
            type: pc.ELEMENTTYPE_IMAGE,
            width: 204,
            height: 36,
            anchor: [0.5, 0.5, 0.5, 0.5],
            pivot: [0.5, 0.5],
            useInput: true,
            spriteAsset: spriteAsset.id,
            spriteFrame: 0
        });

        btnNo.addComponent(pc.eCompomentType.button, {
            active: true,
            imageEntity: btnNo,
            transitionMode: pc.BUTTON_TRANSITION_MODE_SPRITE_CHANGE,
            hoverSpriteAsset: spriteAsset,
            hoverSpriteFrame: 0,
            pressedSpriteAsset: spriteAsset,
            pressedSpriteFrame: 1
        });

        btnNo.setLocalPosition(0, -110, 0);
        wnd.addChild(btnNo);

        btnNo.button.on("click", this.handleClickNoBtn, this);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private updatOverlaySize(): void {
        let w = Game.SCALE.width;
        let h = Game.SCALE.height;

        this._overlay.element.width = w;
        this._overlay.element.height = h;
        this._overlay.setLocalPosition(-w / 2, -h / 2, 0);
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleClickYesBtn(): void {
        // Prehrat reklamu
        if (Gamee.Wrapper.adReady) {
            Gamee.Wrapper.showAd((res: boolean) => {
                if (res) {
                    this.reset();
                    Gameplay.instance.events.fire(KeepPlaying.EVENT_COMPLETE, true);
                }
            }, this);
        }
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    private handleClickNoBtn(): void {
        this.reset();
        Gameplay.instance.events.fire(KeepPlaying.EVENT_COMPLETE, false);
    }
}